'use client';

import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SCOPE3_CATEGORY_BY_SLUG } from '@/features/ghg/config/scope3-categories';
import { GhgCategory3DerivationPage } from '@/features/ghg/pages/GhgCategory3DerivationPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/scope3/$category/derive')({
  beforeLoad: ({ params }) => {
    const config = SCOPE3_CATEGORY_BY_SLUG.get(params.category);
    return {
      getTitle: () =>
        config?.number === 3
          ? i18n.t('ghg:derivationRoute.routeTitle_cat3')
          : i18n.t('ghg:derivationRoute.routeTitle_fallback'),
    };
  },
  component: Scope3CategoryDeriveRoute,
});

function Scope3CategoryDeriveRoute() {
  const { t } = useTranslation('ghg');
  const { category } = Route.useParams();
  const config = SCOPE3_CATEGORY_BY_SLUG.get(category);

  if (!config || config.number !== 3) {
    return (
      <div className="p-8">
        <div className="mx-auto max-w-3xl space-y-6">
          <header>
            <h1 className="text-3xl font-semibold text-foreground">{t('derivationRoute.heading_notAvailable')}</h1>
            <p className="mt-2 text-muted-foreground">
              {t('derivationRoute.description_notAvailable')}
            </p>
          </header>
          <Link className="text-sm text-primary underline" to="/ghg/calculations/scope3">
            {t('derivationRoute.link_openCategories')}
          </Link>
        </div>
      </div>
    );
  }

  return <GhgCategory3DerivationPage />;
}
